// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__1sJY5","list":"TableCells_list__1kcxc","firstItemBold":"TableCells_firstItemBold__1shpN","link":"TableCells_link___H2jx"};